import { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Container,
  Form,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
  FormFeedback,
} from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useCallback } from "react";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import {
  useCreateFormationLevel,
  useDeleteFormationLevel,
  useFormationLevels,
  useUpdateFormationLevel,
} from "../../hooks/useFormationLevels";

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const FonctionsLevel = (props) => {
  const formationLevelsQ = useFormationLevels();
  const createMutation = useCreateFormationLevel();
  const updateMutation = useUpdateFormationLevel();
  const deleteMutation = useDeleteFormationLevel();

  const rawLevels = formationLevelsQ.data || [];
  const formationlevelList = Array.isArray(rawLevels)
    ? rawLevels
    : rawLevels?.results ?? [];

  const [selectedLevel, setSelectedLevel] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const errorMessage =
    typeof formationLevelsQ.error === "string"
      ? formationLevelsQ.error
      : formationLevelsQ.error?.message || "Erreur";

  const onClickDelete = (levelItem) => {
    setSelectedLevel(levelItem);
    setDeleteModal(true);
  };

  const handleDeleteLevel = () => {
    if (!selectedLevel?.id) return;
    deleteMutation.mutate(selectedLevel.id, {
      onSettled: () => setDeleteModal(false),
    });
  };

  const [modal, setModal] = useState(false);
  const [type, setType] = useState({});

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setType({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const [dele, setDele] = useState(0);
  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      del.style.display = "none";
    });
  };

  const niveauxFormation = [
    { label: "Bac", value: "Bac" },
    { label: "Bac+1", value: "Bac+1" },
    { label: "Bac+2", value: "Bac+2" },
    { label: "Bac+3", value: "Bac+3" },
    { label: "Bac+4", value: "Bac+4" },
    { label: "Bac+5", value: "Bac+5" },
    { label: "Master", value: "Master" },
    { label: "Doctorat", value: "Doctorat" },
    { label: "Autre", value: "Autre" },
  ];

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      label: (type && type.label) || " ",
    },

    validationSchema: Yup.object().shape({
      label: Yup.string().required(props.t("Entrer un niveau de formation")),
    }),

    onSubmit: async (values) => {
      if (isEdit === false) {
        const newCategory = {
          label: values.label,
        };

        var count = 0;
        if (newCategory) {
          for (let i = 0; i < formationlevelList.length; i++) {
            if (newCategory.label === formationlevelList[i]?.label) {
              count = count + 1;
              toast.error(props.t("Le niveau de formation existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (count === 0) {
            try {
              await createMutation.mutateAsync(newCategory);
              validation.resetForm();
              setModal(false);
            } catch (_) {
              // handled by toast
            }
          } else {
            count = 0;
          }
        }
      } else {
        const updateCategory = {
          id: type && type.id,
          label: values.label,
        };
        var compte = 0;
        if (updateCategory) {
          for (let i = 0; i < formationlevelList.length; i++) {
            if (updateCategory.label === formationlevelList[i]?.label) {
              compte = compte + 1;
              toast.error(props.t("La fonction existe deja"), {
                autoClose: 3000,
              });
              break;
            }
          }
          if (compte === 0) {
            try {
              await updateMutation.mutateAsync({
                id: updateCategory.id,
                payload: updateCategory,
              });
              validation.resetForm();
              setModal(false);
            } catch (_) {
              // handled by toast
            }
          } else {
            compte = 0;
          }
        }
      }
    },
  });

  const handleContactClick = useCallback(
    (arg) => {
      setType({
        id: arg.id,
        label: arg.label,
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const columns = useMemo(
    () => [
      {
        Header: props.t("NIVEAU DE FORMATION"),
        accessor: "label",
        Cell: (fonctions) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link to="/functions" className="text-dark">
                    {" "}
                    {fonctions.row.original.label}
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const levelData = cellProps.row.original;
          return (
            <div className="d-flex gap-2">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <a
                  className="text-warning d-inline-block"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleContactClick(levelData);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </a>
              </li>
              <Link
                to="#"
                className="text-danger d-inline-block"
                onClick={() => onClickDelete(levelData)}
                title={props.t("Supprimer")}
              >
                <i className="ri-delete-bin-5-line align-middle"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [props, handleContactClick]
  );

  document.title = props.t("Liste des fonctions");

  if (formationLevelsQ.isLoading) return <Loader />;
  if (formationLevelsQ.isError) return <Loader error={errorMessage} />;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteLevel}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Niveau de formation")}
          pageTitle={props.t("Niveau de formation")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-header border-0">
                  <Row className="g-4 align-items-center">
                    <Col sm={5}>
                      <div className="search-box">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder="Rechercher..."
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </Col>
                    <div className="col-sm-auto ms-auto">
                      <div>
                        <button
                          className="btn btn-warning"
                          onClick={() => {
                            setModal(true);
                            setIsEdit(false);
                          }}
                        >
                          <i className="ri-add-fill align-bottom me-1"></i>{" "}
                          Ajouter un niveau de formation
                        </button>
                      </div>
                    </div>
                  </Row>
                  <div className="row align-items-center">
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {dele}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <Modal
                    id="showModal1"
                    isOpen={modal}
                    toggle={toggle}
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3" toggle={toggle}>
                      {!!isEdit
                        ? props.t("Modifier un niveau de formation")
                        : props.t("Ajouter un niveau de formation")}
                    </ModalHeader>

                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={12}>
                            <div>
                              <Label htmlFor="" className="form-label">
                                {props.t("Nom")}
                              </Label>

                              <Input
                                name="label"
                                id="label"
                                className="form-control mb-2"
                                placeholder={props.t("Entrez le nom")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.label || ""}
                                invalid={
                                  validation.touched.label &&
                                  validation.errors.label
                                    ? true
                                    : false
                                }
                              ></Input>
                              {validation.touched.label &&
                              validation.errors.label ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.label}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            {" "}
                            {props.t("Fermer")}{" "}
                          </button>
                          <button type="submit" className="btn btn-warning">
                            {" "}
                            {!!isEdit
                              ? props.t("Modifier")
                              : props.t("Ajouter")}{" "}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  {formationlevelList && formationlevelList.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={formationlevelList || []}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle "
                      theadClass="table-light text-muted"
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5> {props.t("Désolé, pas de resultats trouvés")} </h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
FonctionsLevel.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(FonctionsLevel));
